import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getDataDailyPremiumAccess(authorization) {
  const url = `${API_URL}/admin/app-setting/get-daily-premium-access`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function saveDataDailyPremiumAccess(data, authorization) {
  const url = `${API_URL}/admin/app-setting/set-daily-premium-access`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getCountryList(authorization) {
  const url = `${API_URL}/admin/master/country`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getDataAdsSettings(authorization) {
  const url = `${API_URL}/admin/app-setting/get-ads-setting`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function saveDataAdsSettings(data, authorization) {
  const url = `${API_URL}/admin/app-setting/ads-setting`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDataSkipQuotaSettings(authorization) {
  const url = `${API_URL}/admin/app-setting/get-skip-quota`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function saveDataSkipQuotaSettings(data, authorization) {
  const url = `${API_URL}/admin/app-setting/set-skip-quota`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDataAccountDeleteSurvey(authorization) {
  const url = `${API_URL}/admin/app-setting/get-account-deletion-survey`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function saveAccountDeleteSurvey(data, authorization) {
  const url = `${API_URL}/admin/app-setting/set-account-deletion-survey`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function addAdsFileTemp(file, authorization, onUploadProgress) {
  const url = `${API_URL}/admin/app-setting/upload-temp-file`;
  return axios({
    url,
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getOnBoardingBannerList(authorization) {
  const url = `${API_URL}/admin/master/onboarding-banner`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteOnBoardingBanner(data, authorization) {
  const url = `${API_URL}/admin/master/onboarding-banner`;
  return axios({ url,
    method: 'DELETE',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createOnBoardingBanner(data, authorization) {
  const url = `${API_URL}/admin/master/onboarding-banner/upload`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getReferralBannerList(authorization) {
  const url = `${API_URL}/admin/master/referral-banner`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteReferralBanner(data, authorization) {
  const url = `${API_URL}/admin/master/referral-banner`;
  return axios({ url,
    method: 'DELETE',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createReferralBanner(data, authorization) {
  const url = `${API_URL}/admin/master/referral-banner/upload`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getReferralAboutList(authorization) {
  const url = `${API_URL}/admin/app-setting/get-referral-about-list`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setReferralAboutList(authorization, data) {
  const url = `${API_URL}/admin/app-setting/upsert-referral-about-list`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/appsetting.js